import { render, staticRenderFns } from "./AtividadeCadastro.vue?vue&type=template&id=b4c02b02&"
import script from "./AtividadeCadastro.vue?vue&type=script&lang=js&"
export * from "./AtividadeCadastro.vue?vue&type=script&lang=js&"
import style0 from "./AtividadeCadastro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports